<template>
  <div class="modal">
    <el-dialog :title="`${autoConfig.title}${type == 'add' ? '添加' : '编辑'}`"
               :visible.sync="show"
               @close="dialogFormVisible"
               width="70%"
               @open="getFormFun"
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <div class="modal-ctx"
           v-loading="formLoading">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 status-icon
                 label-width="120px"
                 :validate-on-rule-change="false"
                 >
            <ERouter v-for="(cfg)  in  autoConfig.edit.custom||[]"
                    :key="cfg.prop"
                    :context="context"
                    :config="cfg"></ERouter>
          <template v-if="autoConfig.edit.default.be_time">
            <el-form-item label="起始时间："
                          prop="be_time.begin_date">
              <el-date-picker v-model="ruleForm.be_time.begin_date"
                              type="datetime"
                              size="small"
                              :picker-options="pickerOptionsStart"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="选择日期"
                              :default-value="new Date()"
                              class="width-all">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间："
                          prop="be_time.end_date">
              <el-date-picker v-model="ruleForm.be_time.end_date"
                              type="datetime"
                              size="small"
                              :picker-options="pickerOptionsEnd"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="选择日期"
                              class="width-all">
              </el-date-picker>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary"
                   @click="saveForm"
                   size="small"
                   :loading="loading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import formMixin from "@/quick/N_formMixin";
import genApi, { get } from "@/quick/gen-api";
const { saveFormApi, updateFormApi } = genApi("/World/activityInsectPicture");
import eBase from "../e_base";
export default {
  mixins: [formMixin, eBase],
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "add"
    },
    form: {
      type: Object,
      default: {}
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      saveFormApi: saveFormApi,
      updateFormApi: updateFormApi,
      ruleForm: {
      },
      rules: {
        
      },
    };
  },
  computed: {},

  mounted() {},
  watch: {},
  methods: {
    getFormFun() {
 
        if(this.type == 'add'){

        }
        if (this.type == 'edit') {
            this.$nextTick(() => {
                var form  = _.cloneDeep(this.form)
                for (let key in this.ruleForm) {
                    form[key] ? this.ruleForm[key] = form[key] : '';
                }
            }) 
        }


    },
    saveFormCallBack() {

        let cloneForm = _.cloneDeep(this.ruleForm);
        this.params = {...cloneForm,id: this.id};
        this.params.lang_type = this.$parent.requestData.lang_type
        return true;
    },    
  }
};
</script>

<style scoped></style>
